import { render, staticRenderFns } from "./UpdateRateCard.vue?vue&type=template&id=5e361307&"
import script from "./UpdateRateCard.vue?vue&type=script&lang=js&"
export * from "./UpdateRateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports